import createSagaMiddleware from "redux-saga";

import * as filterActions from "./actions/filters";
import * as ajaxActions from "./actions/ajax";
import {
  SAVED_SEARCH_SELECTED, SAVED_SEARCH_OPTIONS_TRIGGER, SAVED_SEARCH_SUBMIT_TRIGGER,
  DOWNLOAD_SAVED_SEARCH_OPTIONS_TRIGGER
} from "./actions/data_hub_search";

export const sagaMiddleware = createSagaMiddleware();

// responsible for dispatching an AJAX action to the server if the user's action requires it.
// sagas.js will then intercept that action and perform the actual async request and store update.
export const ajaxRequestMiddleware = store => next => action => {
  const dataActionTypes = [
    // some action type, ie. filterActions.YEAR_CHANGED
    ajaxActions.INITIAL_PAGE_LOAD
  ].concat(Object.keys(filterActions));

  const excludeActions = [
    filterActions.EXPAND_PARAMETER_PANEL,
    filterActions.COLLAPSE_PARAMETER_PANEL,
    filterActions.TABLE_MAIN_STANDARDS_EXPANDED,
    filterActions.TABLE_MAIN_REGULATIONS_EXPANDED,
    filterActions.RESET_PARAMETER_AND_COUNTRY_ID
  ];

  const dataRequest = dataActionTypes.find(t => {
    return t === action.type && excludeActions.indexOf(t) === -1;
  });

  const savedSearchSelect = action.type === SAVED_SEARCH_SELECTED;

  const savedSearchOptions = [DOWNLOAD_SAVED_SEARCH_OPTIONS_TRIGGER, SAVED_SEARCH_OPTIONS_TRIGGER].includes(action.type);

  const savedSearchSubmit = action.type === SAVED_SEARCH_SUBMIT_TRIGGER;

  const actionRequiresServerMessage = dataRequest ||
                                      savedSearchSelect ||
                                      savedSearchOptions ||
                                      savedSearchSubmit;
  if (!actionRequiresServerMessage) { return next(action); }

  const result = next(action);
  const newState = store.getState();
  let ajaxAction;
  if (dataRequest) {
    ajaxAction = ajaxActions.dataRequestAjaxAction;
  } else if (savedSearchSelect) {
    ajaxAction = ajaxActions.savedSearchSelectedAjaxAction;
  } else if (savedSearchOptions) {
    ajaxAction = ajaxActions.savedSearchGetOptionsAction;
  } else if (savedSearchSubmit) {
    ajaxAction = ajaxActions.savedSearchSubmitAction;
  } else {
    throw "Gotta handle the new type of AJAX request";
  }

  store.dispatch(ajaxAction(newState, action));
  return result;
};
